import { Button } from '@cad-arc';
import { EditUnitFormType, UserOption } from '@mark43/cad-api';
import { UseFieldArrayReturn, useWatch } from 'react-hook-form';
import { useIntegratedForm } from '../../forms/use-integrated-form';

export function AddPersonnelButton(props: {
    append: UseFieldArrayReturn<EditUnitFormType, 'personnel'>['append'];
}): React.ReactElement {
    const { form, getInputProps } = useIntegratedForm<EditUnitFormType>();
    const callSignValue = useWatch({ control: form.control, name: 'callSign' });
    return (
        <Button
            variant="ghost"
            leadingVisual="Add"
            data-testid="add-personnel-button"
            onClick={() =>
                props.append(({
                    value: undefined,
                    agencyId: undefined,
                    label: undefined,
                } as unknown) as UserOption)
            }
            {...getInputProps({
                isDisabled: !callSignValue,
            })}
        >
            Personnel
        </Button>
    );
}
